import React from 'react';
import sdlc from './assets/sdlc.svg';
import fullstack from './assets/fullstack-development.svg';
import fullstackSelected from './assets/fullstack-development-selected.svg';
import mobile from './assets/mobile-development.svg';
import mobileSelected from './assets/mobile-development-selected.svg';
import webdevelopment from './assets/web-development.svg';
import webdevelopmentSelected from './assets/web-development-selected.svg';
import aws from './assets/aws.svg';
import awsSelected from './assets/aws-selected.svg';
import uiux from './assets/uiux.svg'
import uiuxSelected from './assets/uiux-selected.svg';
import api from './assets/api.svg';
import apiSelected from './assets/api-selected.svg';
import trusted1 from './assets/trustedby1.svg';
import trusted2 from './assets/trustedby2.svg';
import trusted3 from './assets/trustedby3.svg';
import trusted4 from './assets/trustedby4.svg';
import trusted5 from './assets/trustedby5.svg';
import trusted6 from './assets/trustedby6.svg';
import builtEbloc from './assets/builtEbloc.png';
import builtArtMedica from './assets/builtArtMedica.png';
import builtMTGProxy from './assets/builtMTG.png';
import builtClimbingTimer from './assets/builtClimbingTimer.png';
import builtTamato from './assets/builtTamato.png';
import builtLicitatii from './assets/builtLicitatii.png';
import arrowUp from './assets/arrow-up.svg';
import arrowDown from './assets/arrow-down.svg';
import { faRulerCombined, faMarker, faBezierCurve, faWrench, faMicroscope, faCloud, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import HeaderBlack from './components/header-black';
import { Link } from 'react-router-dom';
import './home.css'
import BannerSection from './components/banner';
import Footer from './components/footer';
import Articol from './components/article';
import SlideUpOnScroll from './components/slide-up';
import CredlyBadge from './components/credly-badge';
import {LinkButton} from "./components/link-button";
import SneakPeek from "./components/sneak-peek";

class Sectiunea1 extends React.Component {

    constructor() {
        super();

        this.section1Div = React.createRef();
        this.textDiv = React.createRef();
    }

    componentDidMount() {
        if (window.innerWidth < 600 ) {
            this.section1Div.current.style.height = `${this.textDiv.current.offsetHeight + 50}px`;
        }
    }

    render() {

        const isMobile = window.innerWidth < 600;

        return (

            <div id="section1" ref={this.section1Div} className="section section1-background" >

                <div id='column-text' ref={this.textDiv}>

                    <h1 id='hero-text' className='mb-3'>
                        <span className='t1 white-color-txt mr-1'>Custom software built <br/> around your innovative ideas</span>
                    </h1>


                    <h2 className='b1-s mb-5 mobile-center'>
                        Your vision brought to life through our design and code.<br/>
                        Together, we create software that drives progress and moves things forward.
                    </h2>

                    { !isMobile &&
                        <div className='flex-row row-spacing-2'>
                            <LinkButton to="/services" text="Learn More" className="white-border background-transparent light-button-hover-2" />
                            <LinkButton to="/get-in-touch" text="Get In Touch" className="primary-color white-color-txt no-border" />
                        </div>
                    }

                    { isMobile &&
                        <div className='flex-row row-spacing-2'>
                            <LinkButton to="/services" text="Learn More" className="white-border background-transparent light-button-hover-2" />
                            <LinkButton to="/get-in-touch" text="Contact Us" className="primary-color white-color-txt no-border" />
                        </div>
                    }

                </div>

                {/*Aici era imaginea din dreapta*/}
                {/*<div id='column-hero-image' ref={this.imageDiv}>*/}
                {/*    <img alt='software development tools' src={heroimage} />*/}
                {/*</div>*/}

            </div>

        );
    }
}

class TrustedBy extends React.Component {

    render() {
        const images = [trusted1, trusted2, trusted3, trusted4, trusted5, trusted6];
        const altTexts = ['E-Bloc app', 'CarJoin app', 'Licitatii.binaryfusion.ro', 'tamato mobile app', 'ClimbingTimer app', 'cautadosar.ro', ];
        const duplicatedImages = [...images, ...images, ...images, ...images, ...images];
        const duplicatedAltTexts = [...altTexts, ...altTexts, ...altTexts, ...altTexts, ...altTexts];

        return (
            <div className='image-row-container section1-background'>
                <div id='image-row-overlay'></div>
                <div className='image-row-inner'>

                    {duplicatedImages.map((src, index) => (
                        <img alt={duplicatedAltTexts[index]} src={src} key={index} />
                    ))}

                </div>
            </div>
        );
    }
}

// SERVICES
class Services extends React.Component {

    render() {

        const services = [
            {
                name: 'UI & UX Design',
                image: uiux,
                hoverImage: uiuxSelected,
                text: 'From wireframes to polished prototypes, our UI/UX process combines strategy, creativity, and usability.'
            },
            {
                name: 'Web Development',
                image: webdevelopment,
                hoverImage: webdevelopmentSelected,
                text: "We create web applications of all sizes, from complex, large-scale platforms to smaller, focused projects and even landing pages."
            },
            {
                name: 'Mobile Development',
                image: mobile,
                hoverImage: mobileSelected,
                text: "We can start building your application immediately, ensuring it's functional, fluid, and beautiful."
            },
            {
                name: 'Full-Stack Development',
                image: fullstack,
                hoverImage: fullstackSelected,
                text: "We're proficient in both back-end and front-end development, using technologies we know best."
            },
            {
                name: 'Amazon Web Services',
                image: aws,
                hoverImage: awsSelected,
                text: "Our services bridge the gap between business objectives and cloud technology."
            },
            {
                name: 'API Development',
                image: api,
                hoverImage: apiSelected,
                text: "We build secure, scalable APIs for seamless system integration and smooth data flow excange."
            },
        ];

        return (
            <div id="section2" className="section section-background-2">
                <h1 className='section-title t3 text-center space-above space-bellow'>
                    <SlideUpOnScroll>
                        Solutions and Services
                    </SlideUpOnScroll>
                </h1>

                <div id='services-container'>
                    { services.map((s, index) => <CoreServiceItem name={s.name} image={s.image} hoverImage={s.hoverImage} text={s.text} key={index} /> )}
                </div>

                <SlideUpOnScroll>
                    <LinkButton to="/services" text="Read More" className="mt-6 black-color-txt light-button-hover-2 background-transparent" />
                </SlideUpOnScroll>

                <div className='space-100' />
            </div>
        );
    };
}

class CoreServiceItem extends React.Component {

    render() {

        const { name, image, text} = this.props;

        return (
            <Link to='/services'
                  onMouseEnter={() => this.setState({ isHovered: true })}
                  onMouseLeave={() => this.setState({ isHovered: false })}>
                <div className="flex-column-centered core-service border-radius-12">
                    <img
                      className="service-img-sect-2"
                      alt="web development logo"
                      src={this.state && this.state.isHovered ? this.props.hoverImage || image : image}/>
                    <div className='t5 black'>{name}</div>
                    <div className='b3 black'>{text}</div>

                    <div className='grow'/>
                </div>

            </Link>
        );
    }
}

class LifecycleItem extends React.Component {

    render() {

        this.isLast = this.props.isLast === true;

        return (
            <div className="lifecycle-item blue-hover" onClick={() => this.props.clickAction()}>
                <div className={`flex-row flex-vertical-center planning-item ${this.props.dropdown ? "blue-highlight" : ""}`}>

                    <div className='t4 flex-grow-1 planing-stage-label'>{this.props.label}</div>
                    {this.props.dropdown && <img alt="arrow up" src={arrowUp} /> }
                    {!this.props.dropdown && <img alt="arrow down" src={arrowDown} /> }
                </div>

                {this.props.dropdown &&
                    <div className="dropdown b2">
                        <div>{this.props.content}</div>
                    </div>}

                {!this.isLast && <div className='lifecycle-item-separator' /> }
            </div>
        )
    }
}

class WhatWeBuilt extends React.Component {

    constructor(props) {
        super(props);

        this.innerRef = React.createRef();
        this.offset = 0;
        this.baseSpeed = 0; // px per second, idle auto-scroll speed (derived from layout)
        this.setWidth = 0;
        this.dragging = false;
        this.lastX = 0;
        this.lastFrameTime = 0;
        this.frame = null;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onResize = this.onResize.bind(this);
        this.animate = this.animate.bind(this);
    }

    componentDidMount() {
        this.measure();
        this.lastFrameTime = performance.now();
        window.addEventListener('resize', this.onResize);
        if (window.ResizeObserver && this.innerRef.current) {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.innerRef.current);
        }
        this.frame = requestAnimationFrame(this.animate);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
    }

    measure() {
        if (this.innerRef.current) {
            // the items are duplicated 5 times, one set is a seamless loop unit
            this.setWidth = this.innerRef.current.scrollWidth / 5;
            // one full set every ~18s, a slower idle auto-scroll
            this.baseSpeed = this.setWidth / 40;
        }
    }

    onResize() {
        this.measure();
    }

    onPointerDown(event) {
        this.dragging = true;
        this.lastX = event.clientX;
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
    }

    onPointerMove(event) {
        if (!this.dragging) return;

        this.offset += event.clientX - this.lastX;
        this.lastX = event.clientX;
    }

    onPointerUp() {
        this.dragging = false;
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
    }

    animate(now) {
        const dt = Math.min((now - this.lastFrameTime) / 1000, 0.05);
        this.lastFrameTime = now;

        if (!this.dragging) {
            this.offset -= this.baseSpeed * dt;
        }

        this.wrap();

        if (this.innerRef.current) {
            this.innerRef.current.style.transform = `translateX(${this.offset}px)`;
        }

        this.frame = requestAnimationFrame(this.animate);
    }

    wrap() {
        const width = this.setWidth;
        if (!width) return;

        // keep the offset inside (-width, 0] so the duplicated sets loop seamlessly
        let wrapped = this.offset % width;
        if (wrapped > 0) wrapped -= width;
        this.offset = wrapped;
    }

    render() {

        const builtItems = [
            {
                name: "E-Bloc Android App",
                image: builtEbloc
            },
            {
                name: 'ArtMedica',
                image: builtArtMedica
            },
            {
                name: 'MTG Proxy',
                image: builtMTGProxy
            },
            {
                name: 'ClimbingTimer',
                image: builtClimbingTimer
            },
            {
                name: 'Tamato',
                image: builtTamato,
                blackText: true
            },
            {
                name: 'Licitatii.ro',
                image: builtLicitatii
            },
        ];

        const altTexts = ['E-Bloc app', 'ArtMedica app', 'MTGProxy web app', 'ClimbingTimer app', 'Tamato mobile app', 'Licitatii.ro', ];
        const duplicatedImages = [...builtItems, ...builtItems, ...builtItems, ...builtItems, ...builtItems];
        const duplicatedAltTexts = [...altTexts, ...altTexts, ...altTexts, ...altTexts, ...altTexts];

        return (
            <div className='what-we-built section black-0e-background'>
                <h1 className='page-padding section-title t3 white-color-txt space-above space-bellow'>
                    <SlideUpOnScroll>
                        What we've built
                    </SlideUpOnScroll>
                </h1>

                <div className="built-items-row" onPointerDown={this.onPointerDown}>
                    <div className='built-items-row-inner' ref={this.innerRef}>
                        {duplicatedImages.map((src, index) => (
                            <BuiltItem alt={duplicatedAltTexts[index]} image={src.image} name={src.name} blackText={src.blackText} key={index} />
                        ))}
                    </div>
                </div>

                <div className='space-100' />

            </div>
        );
    }
}

class BuiltItem extends React.Component {
    render() {
        return (
            <div className='built-item'>
                <img alt={this.props.alt} src={this.props.image} draggable={false} />
                <div className={`built-item-name b3 ${this.props.blackText ? 'black-color-txt' : 'white-color-txt'}`}>{this.props.name}</div>
            </div>
        );
    }
}

// CUSTOM SOFTWARE LIFECYCLE
class SoftwareLifecycle extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visibleItem: 0 // indexul item-ului pentru care arat dropdown-ul
        };
    }

    toggleVisibleItem(itemIndex) {

        return () => {
            if (itemIndex === this.state.visibleItem) {
                this.setState({ visibleItem: -1 });
            } else {
                this.setState({ visibleItem: itemIndex });
            }
        }
    }


    render() {
        return (

            <div id="section3" className='page-padding'>

                <div className='two-column-section-title space-above space-bellow'>

                    <SlideUpOnScroll>
                    <h2 className='t3'>
                        Custom software development lifecycle
                    </h2>
                    </SlideUpOnScroll>

                    <SlideUpOnScroll>
                    <div className='section-description b1'>
                        From the first spark of an idea to a launched product, we guide you through every stage — discovery to define your goals, intuitive UX/UI design, agile development, rigorous testing, and post-launch support to keep your software evolving.
                    </div>
                    </SlideUpOnScroll>
                </div>


                <div id='lifecycle' className='extra-mobile-padding'>
                    <div id='lifecycle-items' className='flex-column mb-10'>
                        <LifecycleItem label="Planning"
                            icon={faRulerCombined}
                            dropdown={this.state.visibleItem === 0}
                            clickAction={this.toggleVisibleItem(0)}
                            content="By collecting all the relevant information from the customer we will make sure to provide the best software solution as per their expectation" />

                        <LifecycleItem
                            label="Defining"
                            icon={faBezierCurve}
                            dropdown={this.state.visibleItem === 2}
                            clickAction={this.toggleVisibleItem(2)}
                            content="Define and document software needs such as target performance, scalability expectations, cloud infrastructure external platforms integrations" />

                        <LifecycleItem
                            label="Wireframing"
                            icon={faBezierCurve}
                            dropdown={this.state.visibleItem === 8}
                            clickAction={this.toggleVisibleItem(8)}
                            content="Define and document software needs such as target performance, scalability expectations, cloud infrastructure external platforms integrations" />

                        <LifecycleItem label="Designing"
                            icon={faMarker}
                            dropdown={this.state.visibleItem === 7}
                            clickAction={this.toggleVisibleItem(7)}
                            content="In this stage we will use the gathered customer requirements to obtain and define the overall system arhitecture and technology stack" />

                        <LifecycleItem label="Building"
                            icon={faWrench}
                            dropdown={this.state.visibleItem === 3}
                            clickAction={this.toggleVisibleItem(3)}
                            content="This is the step where your project is becoming a reality. We will start to build the entire system by writing code using the chosen programming language, techniques, and methodologies" />

                        <LifecycleItem label="Testing"
                            icon={faMicroscope}
                            dropdown={this.state.visibleItem === 4}
                            clickAction={this.toggleVisibleItem(4)}
                            content="Will engage in an extensive testing stage when all the client requested features will be closely analized and checked for any defects" />

                        <LifecycleItem label="Deployment"
                            icon={faCloud}
                            dropdown={this.state.visibleItem === 5}
                            clickAction={this.toggleVisibleItem(5)}
                            content="This is the stage when the software will be prepared for release and deployment. If required extra services will be provided to ensure software stability and security" />

                        <LifecycleItem label="Maintenance"
                            isLast={true}
                            icon={faCodeBranch}
                            dropdown={this.state.visibleItem === 6}
                            clickAction={this.toggleVisibleItem(6)}
                            content="According to the service level agreement, we ensure that needs continue to be met and that the system continues to perform as per the decided specifications" />
                    </div>

                    <img id="lifecycle-image" alt="lifecycle development presentation" src={sdlc} />

                </div>
            </div>
        );
    };
}

class Certifications extends React.Component {
    
    render() {
        return <>
            
            <div id="section-certifications" className="background-white flex-column-centered section" >
                
                <div className='section-title t3 space-above space-bellow'>
                    <SlideUpOnScroll delay={600}>
                        Certifications
                    </SlideUpOnScroll>
                </div>
                
                <div className='certifications-items mb-9'>

                    <CredlyBadge badgeId='ceb72a1e-01f9-43dc-adfa-09a9c351774a' />
                    
                    <CredlyBadge badgeId='ea123de4-3c03-4f34-a8ca-0433bad467b7' />
                    
                    <CredlyBadge badgeId='4fc56065-17d2-42fd-9830-9ffde7ecaab6' />

                    <CredlyBadge badgeId='bb4fd77e-7d96-4a6f-ae17-0777b2161a1c' />

                    <CredlyBadge badgeId='61c78bcb-1461-482f-9667-ee0becca1678' />
                </div>
                
            </div>
        </>     
    }
}

class Articole extends React.Component {

    constructor(props) {
        super(props);
        this.articles = [
            {
                title: 'Hosted React WebSite to AWS Amplify',
                route: '/dp-dv-react-to-aws',
                color: 'black',
            },
            {
                title: 'GoLang Web app on AWS (Part 1) - ECR and Lambda',
                route: '/dp-golang-webapp-ecr',
                color: 'blue',
            },
            {
                title: 'GoLang Web app on AWS (Part 2) - Front-end and CORS',
                route: '/dp-golang-webapp-cors',
                color: 'blue',
            },
        ];
    }

    render() {

        return <>
            <div id="section-articole" className="grey-section-background flex-column-centered section" >
                <h2 className='section-title t3 space-above mb-6'>
                    <SlideUpOnScroll delay={600}>
                        Deep Dives
                    </SlideUpOnScroll>
                </h2>

                <div className='section-content b1 space-bellow'>
                    <SlideUpOnScroll delay={400}>
                        Showcases some interesting problems we encountered, the solutions we found or
                        even reading material for inspiration. It paints a good image of the level of
                        technical knowledge of our developer team. You can find more similar articles
                        in the <Link to={'/deep-dives'} className='primary-color-front'>DEEP DIVES</Link> section
                    </SlideUpOnScroll>
                </div>

                <div className='articles'>
                    {this.articles.map((x, index) => <Articol title={x.title} to={x.route} color={x.color} key={index}/> )}
                </div>

                <div className='space-100' />
            </div>

        </>
    }
}



class HomePage extends React.Component {

    sendEvent = () => {
        if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        if (!sessionStorage.getItem('visit')) {
            sessionStorage.setItem('visit', true);

            fetch('https://api.ipify.org?format=json')
                .then((ipResp) => ipResp.json().then((ipJson) => {
                    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ type: 'visit', name: 'binaryfusion.ro', from: ipJson }),
                    }).then((response) => response.json().then((responseData) => {
                        sessionStorage.setItem('success', responseData.EventId);
                    }));
                })
                );
        }
    }

    componentDidMount() {
        this.sendEvent();
        
        window.scrollTo(0, 0);

        const head = document.head;
        const url = `https://www.binaryfusion.ro/`;

        // Check if a canonical link already exists
        let link = document.querySelector("link[rel='canonical']");

        if (link) {
            // Update existing link
            link.setAttribute("href", url);
        } else {
            // Create a new link element
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            link.setAttribute("href", url);
            head.appendChild(link);
        }
    }

    render() {

        return (
            <div id="all-sections">
                <HeaderBlack />

                <div className='hero-back-image'>
                    <Sectiunea1 />

                    <TrustedBy />
                </div>

                <Services />

                <WhatWeBuilt />

                <SoftwareLifecycle />
                
                <Articole />

                <Certifications />

                <SneakPeek />

                <BannerSection />
                
                <Footer />
            </div>
        );

    }
}

export default HomePage;